import React from "react";
import { GetPageResponse } from "@store/features/crm/pageV2Slice";
import { DataType } from "skedyul-db/browser";
import { Params } from "../../helpers";
import { getByPath, getErrorForRowAndPath } from "./utils";
import type { FieldAppearance } from "skedyul-core/features/crm";
import { displayFieldInputValue } from "../form/fieldValue";

export const createInputCell = (
  field: {
    type: DataType;
    definition?: { type?: string; appearance?: FieldAppearance } | null;
    appearance?: FieldAppearance;
    label?: string;
  },
  _params: Params,
  accessorPath: string,
  pageData?: GetPageResponse,
) => {
  // Resolve placeholder from appearance (field -> definition -> fallback)
  const placeholder =
    (field.appearance?.placeholder as string | undefined) ||
    (field.definition?.appearance?.placeholder as string | undefined) ||
    `Enter ${field.label || accessorPath}`;

  return {
    component: "Input" as const,
    generateProps: (
      row: Record<string, unknown>,
      _index: number,
      originalRow?: Record<string, unknown>,
    ) => ({
      id: accessorPath,
      value: displayFieldInputValue(getByPath(row, accessorPath)),
      originalValue: originalRow
        ? displayFieldInputValue(getByPath(originalRow, accessorPath))
        : "",
      type:
        field.type === DataType.NUMBER
          ? ("number" as const)
          : ("text" as const),
      multiline: field.type === DataType.LONG_STRING || undefined,
      placeholder,
      fieldError: getErrorForRowAndPath(row, accessorPath, pageData || null),
      handleChange: (_e: React.ChangeEvent<HTMLInputElement>) => {
        /* no-op */
      },
    }),
  };
};
